import { Popover } from "radix-ui";
import TLink from "../Table/TLink";
import IconShareLink from "../icons/IconShareLink";
import Button from "@/components/bricks/button/Button";

export type ErklaeringType = "klienterklaering" | "tilsynserklaering";

export default function TLinkButton({
  id,
  erklaeringtype,
}: {
  id: string;
  erklaeringtype: ErklaeringType;
}) {
  return (
    <Popover.Root modal>
      <Popover.Trigger asChild>
        <Button color="secondary" size="sm">
          <IconShareLink />
          <span className="ms-1">Weberklæring</span>
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <TLink id={id} type={erklaeringtype} heading="Link til weberklæring" />
      </Popover.Portal>
    </Popover.Root>
  );
}
